import { getColor } from 'common/constants/_colors';
import { TooltipStyled, LegendSymbol } from 'components/base/layout-components';
import LegendItem from './LegendItem';

const PieBreakdownTooltip = ({ active, payload, legendData }) => {
  if (!active || !payload) {
    return null;
  }

  const {
    payload: { key }
  } = payload[0];
  const { color, name, subValue, value } = legendData.find(
    item => item.key === key
  );

  return (
    <TooltipStyled padding='0.5rem 0 0 1rem'>
      <LegendItem
        icon={<LegendSymbol type='square' backgroundColor={getColor(color)} />}
        sum={value}
        subValue={subValue}
        name={name}
        isHorizontalView={false}
      />
    </TooltipStyled>
  );
};

export default PieBreakdownTooltip;
